import React, {useState} from 'react';
import {Form, Button} from 'react-bootstrap';
import {
    serviceActions,
    useServiceReducer,
  } from "../../../reducers/serviceReducer";
import { analyze } from "../../../services/Engine";

export default function AnalysisForm(props){
    const [serviceState, serviceDispatch] = useServiceReducer();

  const [testOnly, setTestOnly] = useState(true);
  const [text, setText] = useState("");
  async function submitForm() {
    serviceDispatch({ type: serviceActions.LOADING });
    try {
      const result = await analyze(props.engine,{ text: text, testOnly: testOnly });
      serviceDispatch({ type: serviceActions.SUCCESS });
      props.onResult(text, result);
    } catch (err) {
      console.log("error", err);
      serviceDispatch({ type: serviceActions.ERROR, payload: err.message });
      props.onResult(text, null);
    }
  }
   return(<Form>
    <div className="float-right">
      <Form.Check
        onChange={(e) => {
          setTestOnly(e.target.checked);
        }}
        type="switch"
        checked={testOnly}
        disabled={true}
        id="custom-switch"
        label="Only for testing"
      />
    </div>
    <Form.Group controlId="exampleForm.ControlTextarea1">
      <Form.Label>English text for analysis</Form.Label>
      <Form.Control
        as="textarea"
        rows="10"
        required
        onChange={(e) => {
          setText(e.target.value);
        }}
      />
      <small>
        {testOnly
          ? "In test mode: The analysis engine will not store the result."
          : "Not in test mode: The analysis engine will store the result."}
      </small>
    </Form.Group>
    <Button
      variant="outline-primary"
      disabled={serviceState.loading || !text.trim().length}
      onClick={() => submitForm()}
    >
      Submit
    </Button>
  </Form>) 
}